import React from "react"
import "./frames.css"

const Medico = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Médico</h1>
      <p className="frames-text">
        Ponemos a tu disposición una red de médicos capaces de liderar tu
        proyecto o sencillamente asesorarte cuando lo necesites. Consulta las
        diferentes opciones disponibles para asegurar que tu unidad de medicina
        hiperbárica tenga el respaldo profesional que merece.
      </p>
    </div>
  )
}

export default Medico
